<template>
    <div class="modal-edicao mb-3 modal-edicao-label mt-6">
		<EditAccount
			v-if="modalAccount"
			:accountData="{}"
			@closeModal="closeAccount"
			@newAccount="setAccount"
			:name="nameAccount"
		/>
		<EditCategoryExpenses
			v-if="modalCategory"
			:categoryExpenseData="{}"
			@closeModal="closeCategory"
			@newCategoryExpense="setCategory"
			:name="nameCategory"
		/>
        <b-row >
            <b-col cols="8" class="text-parcela pr-1">
                <label class="label-parcela">Data Lançamento</label>
                <div class="d-flex">
                    <datepicker
                        class="w-100"
                        placeholder=""
                        id="data-lancamento"
                        input-class="bg-white"
                        v-model="transactionUpsert_date"
                        :format="formatter"
                        :language="ptBR"
                        :bootstrap-styling="true"
                        data-cy="Data Lançamento"
                        :disabled="editing"
                    />
                </div>
            </b-col>
            <b-col cols="4" class="d-block text-parcela pl-1">
                <span class="label-conta">Valor</span>
                <b-form-input
                    name="valor"
                    class="modal-edicao-input number-class"
                    v-model="transactionUpsert_amount"
                    autocomplete="off"
                    placeholder=""
                    inputmode="numeric"
                    v-validate="'required|noZeroCurrency'"
                    :state="validateState('valor')"
                    :disabled="editing"
                    @input="updateValue(transactionUpsert_amount)"
                    @focus="handleFocus('transactionUpsert_amount')"
                    @blur="handleBlur('transactionUpsert_amount')"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col :cols="editing ? 12 : 8" class="text-parcela mb-2" v-bind:class="!editing ? 'pr-1' : ''">
                <span class="label-conta">
                    Carteira Origem
                </span>
				<SearchSelect
					:key="'accountSource'"
					name="accountSource"
					:options="account.filter(item => !item.inactive && item.permitePagamento && (!transactionUpsert_idAccount || transactionUpsert_idAccount !== item.value))"
					:visibleSuggestion="visibleSuggestion.accountSource"
					:isMobile="isMobile"
					:newRecord="newAccountSource"
					:clearSelect="clearSelect"
					@changeSelect="changeSelect"
					@handleSuggestion="handleVisibleSuggestion"
					@invalidSearch="validateOptionSearch"
				/>
            </b-col>
            <b-col v-if="!editing" cols="4" class="text-parcela mb-2 pl-1">
                <span class="label-conta">Balance</span>
                <b-form-input
                    name="accountBalance"
                    class="modal-edicao-input number-class"
                    v-model="accountBalance"
                    :disabled="true"
                />
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" class="text-parcela">
                <span class="label-conta">
                    Carteira Destino
                </span>
				<SearchSelect
					:key="'accountTarget'"
					name="accountTarget"
					:options="account.filter(item => !item.inactive && item.permitePagamento && (!transactionUpsert_idAccountExpense || transactionUpsert_idAccountExpense !== item.value))"
					:visibleSuggestion="visibleSuggestion.accountTarget"
					:isMobile="isMobile"
					:newRecord="newAccountTarget"
					:clearSelect="clearSelect"
					@changeSelect="changeSelect"
					@handleSuggestion="handleVisibleSuggestion"
					@invalidSearch="validateOptionSearch"
				/>
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col cols="12" class="text-parcela">
                <span class="label-conta">
                    Categoria da Transação
                </span>
				<SearchSelect
					:key="'category'"
					name="category"
					:options="category.filter(item => !item.inactive)"
					:visibleSuggestion="visibleSuggestion.category"
					:isMobile="isMobile"
					:newRecord="newCategory"
					:clearSelect="clearSelect"
					@changeSelect="changeSelect"
					@handleSuggestion="handleVisibleSuggestion"
					@invalidSearch="validateOptionSearch"
				/>
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col cols="12" class="d-block text-parcela">
                <span class="label-conta">Observações</span>
                <b-form-input
                    name="comments"
                    class="modal-edicao-input"
                    v-model="transactionUpsert_comments"
                    autocomplete="off"
                    placeholder=""
                    v-validate="'maxLength:255'"
                    :state="validateState('comments')"
                />
            </b-col>
        </b-row>
    </div>
</template>

<script>
	import dayjs from "dayjs";
	import "dayjs/locale/pt-br";
	import Datepicker from "vuejs-datepicker";
	import { ptBR } from "vuejs-datepicker/dist/locale";
	import { hasFieldsWithErrors } from "@/helpers/validators";
	import { possuiPermissao } from "../../helpers/permissions";
	import { numberFormatted, stringToNumber, validateNumber, isNullValue, removeAccents } from "@/helpers/common";
	import { TransactionService } from "../../services/transaction";
	import { mapState } from "vuex";
	import EditAccount from "@/views/Account/EditAccount.vue";
	import EditCategoryExpenses from "@/views/CategoryExpenses/EditCategoryExpenses.vue";
	import SearchSelect from "@/components/SearchSelect.vue";

	export default {
		name: "FormTransfer",
		components: {
			Datepicker,
			EditAccount,
			EditCategoryExpenses,
			SearchSelect
		},

		props: {
			transactionDocument: {
				type: Object,
				required: true
			},
			toSave: {
				type: Boolean,
				required: true
			},
			clearFields: {
				type: Boolean,
				required: true
			},
			isMobile: {
				type: Boolean,
				required: false
			}
		},
		data () {
			return {
				possuiPermissao,
				ready: true,
				loading: false,
				ptBR,

				transactionUpsert_idTransaction: null,
				transactionUpsert_comments: "",
				transactionUpsert_idCategory: null,
				transactionUpsert_idAccount: null,
				transactionUpsert_idAccountExpense: null,
				transactionUpsert_date: new Date(),
				transactionUpsert_amount: "0,00",
				editing: false,
				saving: false,
				invalidForm: true,
				accountBalance: "0,00",
				insufficientBalance: true,
				transactionService: new TransactionService(),

				accountOptions: [],
				categoryOptions: [],
				modalAccount: false,
				modalCategory: false,
				visibleSuggestion: {
					accountSource: false,
					accountTarget: false,
					category: false
				},
				nameAccount: "",
				nameCategory: "",
				invalidSearch: {
					accountSource: true,
					accountTarget: true,
					category: true
				},
				newCategory: {},
				newAccountSource: {},
				newAccountTarget: {},
				clearSelect: false,
				selectAccountSource: false
			};
		},

		watch: {
			toSave () {
				if (this.toSave) this.save();
			},
			clearFields () {
				if (this.clearFields) this.clearModal();
			}
		},

		computed: mapState(["account", "category", "accountClass"]),

		async mounted () {
			if (this.transactionDocument.idTransaction) {
				this.transactionUpsert_idTransaction = this.transactionDocument.idTransaction;
				this.transactionUpsert_comments = this.transactionDocument.comments || "";
				this.transactionUpsert_idCategory = this.transactionDocument.idCategory;
				this.transactionUpsert_idAccount = this.transactionDocument.idAccount;
				this.transactionUpsert_idAccountExpense = this.transactionDocument.idAccountExpenseTransfer;
				this.transactionUpsert_date = new Date(this.transactionDocument.transactionDate);
				this.transactionUpsert_amount = numberFormatted(this.transactionDocument.transactionAmount);
				this.editing = true;
			}
		},

		methods: {
			async updateValue (value) {
				this.transactionUpsert_amount = await validateNumber(value);
				this.validateBalanceAccountExpense();
			},

			closeSelectTransaction () {
				this.$emit("closeSelectTransaction", true);
			},

			closeFormTransaction () {
				this.$emit("closeFormTransaction", true);
			},

			formatter (date) {
				return dayjs(date).locale("pt-br").format("D [de] MMMM [de] YYYY");
			},

			handleFocus (key) {
				if (isNullValue(this[key])) this[key] = "";
				else this[key] = this[key].replace(/\./g, "");
			},

			handleBlur (key) {
				if (this[key]) {
					this[key] = numberFormatted(stringToNumber(this[key]));
				}
			},

			async save () {
				this.saving = true;
				const payload = {
					comments: this.transactionUpsert_comments,
					idIncomeAccount: this.transactionUpsert_idAccount,
					idExpenseAccount: this.transactionUpsert_idAccountExpense,
					idCategoryIncome: this.transactionUpsert_idCategory,
					date: this.transactionUpsert_date,
					amount: this.transactionUpsert_amount.replace(/\./g, "").replace(",", "."),
					idTransaction: this.transactionUpsert_idTransaction
				};

				const config = {
					timeout: 2000,
					showProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true
				};

				this.$snotify.async("Aguarde...", "Salvando", async () => {
					try {
						this.saving = true;
						if (payload.idTransaction)
							await this.transactionService.updateTransaction({payload});
						else {
							payload.transactionType = "TRANSFER";
							payload.status = "PAID";
							await this.transactionService.createTransaction({payload});
						}

						this.clearModal();
						this.$emit("saved", true);
						this.saving = false;

						return {
							title: "Sucesso!",
							body: "Transação salva com sucesso.",
							config
						};
					} catch (error) {
						this.$emit("saved", false);
						this.saving = false;
						const msgError = error.response.data.message || "Erro ao tentar salvar a Transação!";
						throw {
							title: "Falha!",
							body: msgError,
							config
						};
					}
				});
			},

			clearModal () {
				this.transactionUpsert_idTransaction = null;
				this.transactionUpsert_comments = "";
				this.transactionUpsert_idCategory = null;
				this.transactionUpsert_idAccount = null;
				this.transactionUpsert_idAccountExpense = null;
				this.transactionUpsert_date = new Date();
				this.transactionUpsert_amount = "0,00";
				this.saving = false;
				this.editing = false;
				this.invalidForm = true;
				this.accountBalance = "0,00";
				this.insufficientBalance = true;

				this.clearSelect = !this.clearSelect;

				this.$emit("clearedFields", true);
			},

			validateState (ref) {
				this.invalidForm = hasFieldsWithErrors(this.veeFields);
				this.$emit("invalidForm", Boolean(this.invalidForm || this.insufficientBalance || this.invalidSearch.accountSource || this.invalidSearch.accountTarget || this.invalidSearch.category));
				if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated))
					return !this.veeErrors.has(ref);

				return null;
			},

			validateAccount (select) {
				if (this.transactionUpsert_idAccountExpense === this.transactionUpsert_idAccount) {
					if (select === "expense") {
						this.transactionUpsert_idAccountExpense = null;
					} else {
						this.transactionUpsert_idAccount = null;
					}
				}

				if (select === "expense") {
					this.validateBalanceAccountExpense();
				}
			},

			validateBalanceAccountExpense () {
				this.accountBalance = numberFormatted((this.account.filter(account => account.value === this.transactionUpsert_idAccountExpense))[0]?.balance || "0");

				let balance = this.accountBalance.replace(/\./g, "");
				balance = parseFloat(balance.replace(",", "."));

				let valor = this.transactionUpsert_amount.replace(/\./g, "");
				valor = parseFloat(valor.replace(",", "."));
				this.insufficientBalance = Boolean(balance < valor);

				this.$emit("invalidForm", this.insufficientBalance);
			},

			showAccount () {
				this.modalAccount = true;
			},

			closeAccount (cancelled) {
				if (cancelled) {
					this.nameAccount = "";
				}

				this.modalAccount = false;
			},

			setAccount (newAccount) {
				const automaticPay = (this.accountClass.find(ac => ac.idAccountClass === newAccount[0].idAccountClass)).automaticPay || null;

				if (this.selectAccountSource) {
					this.newAccountSource = {
						id: newAccount[0].idAccount,
						description: newAccount[0].description
					};
					// Verificar rules of record
					if (newAccount.inactive || !automaticPay) {
						this.newAccountSource.notPermited = true;
					}

				} else {
					this.newAccountTarget = {
						id: newAccount[0].idAccount,
						description: newAccount[0].description
					};
					// Verificar rules of record
					if (newAccount.inactive || !automaticPay) {
						this.newAccountTarget.notPermited = true;
					}
				}

			},

			changeSelect (option) {
				const { value, text, fatherComponent } = option;
				if (value) {
					if (fatherComponent === "accountSource") {
						this.selectAccountSource = true;
						this.transactionUpsert_idAccountExpense = value;
						this.nameAccount = text;
						this.validateBalanceAccountExpense();
					} else if (fatherComponent === "accountTarget") {
						this.selectAccountSource = false;
						this.transactionUpsert_idAccount = value;
						this.nameAccount = text;
						this.validateBalanceAccountExpense();
					} else {
						this.transactionUpsert_idCategory = value;
						this.nameCategory = text;
					}
				} else {
					if (fatherComponent === "accountSource") {
						this.selectAccountSource = true;
						this.nameAccount = text;
						this.showAccount();
					} else if (fatherComponent === "accountTarget") {
						this.selectAccountSource = false;
						this.nameAccount = text;
						this.showAccount();
					} else {
						this.nameCategory = text;
						this.showCategory();
					}
				}
			},

			showCategory () {
				this.modalCategory = true;
			},

			closeCategory (cancelled) {
				if (cancelled) {
					this.nameCategory = "";
				}

				this.modalCategory = false;
			},

			setCategory (newCategoryExpense) {
				this.newCategory = {
					id: newCategoryExpense[0].idCategoryExpense,
					description: newCategoryExpense[0].description
				};
			},

			validateOptionSearch (validateSearch) {
				this.invalidSearch[validateSearch.fatherComponent] = validateSearch.invalidSearch;
				if (validateSearch.fatherComponent === "accountSource" && validateSearch.invalidSearch) {
					this.accountBalance = "0,00";
				}
			},

			handleVisibleSuggestion (handleSuggestion) {
				if (handleSuggestion.visibleSuggestion) {
					const visibleSuggestionKeys = Object.keys(this.visibleSuggestion);
					visibleSuggestionKeys.forEach((vsk) => {
						if (vsk === handleSuggestion.name) {
							this.visibleSuggestion[vsk] = handleSuggestion.visibleSuggestion;
						} else {
							this.visibleSuggestion[vsk] = false;
						}
					});
				} else {
					this.visibleSuggestion[handleSuggestion.name] = handleSuggestion.visibleSuggestion;
				}
			}
		}
	};

</script>